import _ from '../helper/HelperFunctions';

/**
 * How to use
 * @param {clickTargetsArray} element this/these is/are the element(s) that are/is clicked to trigger the popup it needs the class "popup-trigger"
 * 
 * After having created the popup trigger, within the same element there needs to be a div with the class "popup-window". This is what
 * this script will look for when a popup trigger is clicked
 * 
 * Within the popup-window there needs to be a div with the class "popup-window__background" and an icon/div with the class "popup-window__close"
 * 
 * Example markup:
 * 
 * 	<div class="popup-window">
 * 		<div class="popup-window__background"></div>
 * 		<div class="popup-window__close icon-times"></div>
 * 		<div class="popup-window__content">
 * 			<!-- Insert content here -->
 * 		</div>
 * 	</div>
 */

export default class VlPopup {
	constructor(clickTargetsArray) {
		this.popupTriggers = clickTargetsArray;
		this.parentNode;
		this.adjacentPopupWindow;
		this.bodyContainer = document.querySelector('body > .page-wrapper');
		this.footer = document.querySelector('body > footer');

		if (_.clickEvent() === 'touchend') {
			this.setMobileTriggerListeners();
		} else {
			this.setTriggerListeners();
		}
	}

	setTriggerListeners() {
		this.popupTriggers.forEach(function(trigger) {
			var window = trigger.parentNode.querySelector('.popup-window')
			
			document.body.appendChild( window )

			this.setCloseListener(window.querySelector('.popup-window__close'));
			this.setCloseListener(window.querySelector('.popup-window__background'));

			trigger.addEventListener(_.clickEvent(), function(e) {
				e.preventDefault();
				e.stopPropagation();
				
				this.parentNode = trigger.parentElement;
				this.adjacentPopupWindow = window;

				this.adjacentPopupWindow.classList.add('active');

				this.bodyContainer.classList.add('popup-window-active');
				this.footer.classList.add('popup-window-active');
				_.disableBodyScroll(true);

				var video = this.adjacentPopupWindow.querySelector('video')

				if( video )
				{
					video.play()
				}
				
			}.bind(this), false)
		}.bind(this), false);
	}

	setCloseListener(element) {
		element.addEventListener(_.clickEvent(), function(e) {
			e.preventDefault();
			this.adjacentPopupWindow.classList.remove('active');
			this.bodyContainer.classList.remove('popup-window-active');
			this.footer.classList.remove('popup-window-active');
			
			var video = this.adjacentPopupWindow.querySelector('video')

			if( video )
			{
				video.pause()
			}
			
			_.disableBodyScroll(false);
		}.bind(this), false)
	}

	setMobileTriggerListeners() {
		this.popupTriggers.forEach(function(trigger) {

			var window = trigger.parentNode.querySelector('.popup-window')
			
			document.body.appendChild( window )

			this.setCloseListener(window.querySelector('.popup-window__close'));
			this.setCloseListener(window.querySelector('.popup-window__background'));

			trigger.addEventListener(_.clickEvent(), function(e) {

				if (!_.isDragging() && e.cancelable) {
					e.preventDefault();
					this.parentNode = trigger.parentElement;
					this.adjacentPopupWindow = window

					this.adjacentPopupWindow.classList.add('active');

					this.bodyContainer.classList.add('popup-window-active');
					this.footer.classList.add('popup-window-active');
					_.disableBodyScroll(true);
				}
			}.bind(this), false)
		}.bind(this), false);
	}
}